import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "@app/components/toastr/toast.service";

@Component({
  selector: "app-city-create",
  templateUrl: "./city-create.component.html",
  styleUrls: ["./city-create.component.scss"],
})
export class CityCreateComponent implements OnInit {
  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;
  country = null;
  state = null;

  constructor(
    private ActivatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      this.http
        .get<any>(`${environment.apiUrl}/city/${id}`, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (data) => {
            console.log(data);
            // console.log("data");

            data.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (data != null) {
              this.action = "Update";
              this.Form.patchValue({
                _id: data._id,
                state: data.state,
                country: data.country,
                name: data.name,
                image: data.image,
                status: data.status,
                priority: data.priority,
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });
    this.http
      .get<any>(`${environment.apiUrl}/state/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          // console.log(data);

          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.state = data.results;
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );

    this.http
      .get<any>(`${environment.apiUrl}/country/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.country = data.results;
        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );

    this.Form = this.formBuilder.group({
      country: ["", Validators.required],
      state: ["", Validators.required],
      name: ["", Validators.required],
      image: ["", Validators.required],
      status: ["", Validators.required],
      priority: ["", Validators.required],
      _id: [""],
    });
  }



  get f() {
    return this.Form.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if (this.action == "Submit") {
      let data = {
        country: this.Form.value.country,
        state: this.Form.value.state,
        name: this.Form.value.name,
        image: this.Form.value.image,
        status: this.Form.value.status,
        priority: this.Form.value.priority,
      };
      console.log(data);

      this.http
        .post<any>(`${environment.apiUrl}/city/`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Added";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Added", "success");
              
              this.router.navigateByUrl("/city/list");
            }
          },
          (err: HttpErrorResponse) => {
            this.toast.show("Failed to save City", "error");
          }
        );
    } else {
      let data = {
        country: this.Form.value.country,
        state: this.Form.value.state,
        name: this.Form.value.name,
        image: this.Form.value.image,
        status: this.Form.value.status,
        priority: this.Form.value.priority,
      };
      console.log(data);

      let id = this.Form.value._id;
      console.log(id);

      this.http
        .patch<any>(`${environment.apiUrl}/city/${id}`, data, {
          headers: {
            Userinfo: JSON.stringify({
              _id: localStorage.getItem("adminSess"),
              role: localStorage.getItem("userRole"),
            }),
          },
        })
        .subscribe(
          (res) => {
            res.message == "Logged Out!"
              ? this.router.navigateByUrl("/auth/login")
              : "";
            if (res.status == "500") {
              this.message = res.message;
              this.class = "btn-primary rounded px-1 py-1";
              window.scrollTo(document.documentElement.clientWidth, 0);
              return 0;
            } else {
              this.message = "Successfully Updated";
              this.class = "btn-success rounded px-1 py-1";
              this.toast.show("Successfully Updated", "success");
              this.router.navigateByUrl("/city/list");
            }
          },
          (err: HttpErrorResponse) => {
            this.toast.show("Failed to save City", "error");
          }
        );
    }
  }
}
